module.exports = __webpack_public_path__ + "static/media/map_pin_mb_gray.6be9baec.svg";